import React, { useContext } from "react";
import {
  AutocompleteDropdown,
  CommonDropdown,
  SimpleDropdown,
} from "@/components";
import { usePriceTypes } from "@/hooks";
import { string, bool, func, oneOf } from "prop-types";
import { useTextDomainContext } from "@/app//providers";

export const PriceTypeDropdownCommon = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const options = usePriceTypes(props as any);
  const propsDefault = {
    componentLabel: gettext("Price type"),
  };

  // Use props directly with fallback instead of state
  const componentLabel = props.componentLabel || propsDefault.componentLabel;

  return (
    <>
      {props.visualStyle === "autoComplete" && (
        <AutocompleteDropdown
          options={
            options as unknown as import("@/types/Dropdown.types").DropdownOption[]
          }
          componentLabel={componentLabel}
          showAll={props.showAll}
          defaultValue={props.defaultValue}
          onChange={props.onChange}
          size="small"
        />
      )}

      {props.visualStyle === "simple" && (
        <SimpleDropdown
          options={
            options as unknown as import("@/types/Dropdown.types").DropdownOption[]
          }
          componentLabel={componentLabel}
          showAll={props.showAll}
          defaultValue={props.defaultValue}
          onChange={props.onChange}
        />
      )}

      {props.visualStyle === "old" && (
        <CommonDropdown
          options={
            options as unknown as import("@/types/Dropdown.types").DropdownOption[]
          }
          componentLabel={componentLabel}
          showAll={props.showAll}
          defaultValue={props.defaultValue}
          onChange={props.onChange}
        />
      )}
    </>
  );
};

PriceTypeDropdownCommon.propTypes = {
  componentLabel: string,
  defaultValue: string,
  showAll: bool,
  onChange: func,
  visualStyle: oneOf(["autoComplete", "autoCompleteMulti", "simple", "old"])
    .isRequired,
};
